<template>
  <div>
    <section class="sub-banner01 banner-top02 position-relative float-start w-100">
      <TitAndBread></TitAndBread>
    </section>

    <main class="float-start w-100">
      <section class="comon-features-div py-5 d-inline-block w-100">
        <div class="container">
          <div class="row row-cols-1 row-cols-lg-2">
            <div class="col">
              <h6 class="subt-text"> 特色 一 </h6>
              <h2 class="main-head-text text-white mt-4"> 文本创造的崭新时代 </h2>
              <p class="mt-3 sub-para text-color">
                AI文本创造技术正在开启全新的文本创作时代，通过强大的自然语言生成能力，大数据支持和个性化定制功能，能够实现高效、灵活、多样化的文本创作，满足各种不同领域的需求。它可以生成流畅、连贯的文章内容，同时也可根据用户需求进行个性化定制，并且成为未来文本创作领域的重要发展方向。
              </p>
              <ul>
                <li>
                  <span class="ion0"> <i class="far fa-check-circle"></i> </span>
                  <span> 强大的自然语言生成能力 </span>
                </li>
                <li>
                  <span class="ion0"> <i class="far fa-check-circle"></i> </span>
                  <span> 大数据支持和实时更新</span>
                </li>

                <li>
                  <span class="ion0"> <i class="far fa-check-circle"></i> </span>
                  <span> 个性化定制和自动化生成</span>
                </li>

              </ul>
              <a data-bs-toggle="modal" data-bs-target="#loginModal" class="btn btn-write mt-5">
                立即开始
                <span class="btnImg">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-arrow-up-short" viewbox="0 0 16 16">
                    <path fill-rule="evenodd"
                      d="M8 12a.5.5 0 0 0 .5-.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 .5.5z">
                    </path>
                  </svg>
                </span>
              </a>
            </div>
            <div class="col">
              <figure>
                <img alt="su" src="static/static/picture/feature-illustration-1-dark.svg">
              </figure>
            </div>
          </div>

          <div class="row row-cols-1 mt-5 mt-lg-0 row-cols-lg-2 flex-lg-row-reverse">
            <div class="col">
              <h6 class="subt-text"> 特色 二 </h6>
              <h2 class="main-head-text text-white mt-4">数据分析的前沿应用 </h2>
              <p class="mt-3 sub-para text-color">AI数据分析已经成为了企业决策、市场预测、消费行为分析等领域的重要工具。
                AI数据分析能够处理和分析大规模的数据，挖掘数据背后的价值和规律，为企业提供更准确的决策支持；同时，它也可以通过智能算法和模型预测市场趋势和消费者行为，帮助企业更好地制定营销策略和产品定位。</p>
              <ul>
                <li>
                  <span class="ion0"> <i class="far fa-check-circle"></i> </span>
                  <span> 自动化地处理大规模数据 </span>
                </li>
                <li>
                  <span class="ion0"> <i class="far fa-check-circle"></i> </span>
                  <span> 个性化解决方案和智能决策支持</span>
                </li>

                <li>
                  <span class="ion0"> <i class="far fa-check-circle"></i> </span>
                  <span> 智能地预测未来发展趋势并进行优化 </span>
                </li>

              </ul>
              <a data-bs-toggle="modal" data-bs-target="#loginModal" class="btn btn-write mt-5">
                立即开始
                <span class="btnImg">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-arrow-up-short" viewbox="0 0 16 16">
                    <path fill-rule="evenodd"
                      d="M8 12a.5.5 0 0 0 .5-.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 .5.5z">
                    </path>
                  </svg>
                </span>
              </a>
            </div>
            <div class="col">
              <figure>
                <img alt="su" src="static/static/picture/feature-illustration-2-dark.svg">
              </figure>
            </div>
          </div>

          <div class="row row-cols-1 row-cols-lg-2">
            <div class="col">
              <h6 class="subt-text"> 特色 三 </h6>
              <h2 class="main-head-text text-white mt-4">创新艺术AI绘图 </h2>
              <p class="mt-3 sub-para text-color">
                AI绘图技术以其智能创作和个性化定制的特点，正在引领艺术创作的智能革新。通过先进的人工智能技术，AI绘图能够为艺术家和设计师提供创新设计灵感，帮助他们更高效地进行艺术创作，为艺术领域带来新的可能性。</p>
              <ul>
                <li>
                  <span class="ion0"> <i class="far fa-check-circle"></i> </span>
                  <span> 文生图智能创作 </span>
                </li>
                <li>
                  <span class="ion0"> <i class="far fa-check-circle"></i> </span>
                  <span> 图生图创新设计 </span>
                </li>
                <li>
                  <span class="ion0"> <i class="far fa-check-circle"></i> </span>
                  <span> 根据用户的需求和偏好进行个性化定制 </span>
                </li>
              </ul>
              <a data-bs-toggle="modal" data-bs-target="#loginModal" class="btn btn-write mt-5">
                立即开始
                <span class="btnImg">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-arrow-up-short" viewbox="0 0 16 16">
                    <path fill-rule="evenodd"
                      d="M8 12a.5.5 0 0 0 .5-.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 .5.5z">
                    </path>
                  </svg>
                </span>
              </a>
            </div>
            <div class="col">
              <figure>
                <img alt="su" src="static/static/picture/feature-illustration-3-dark.svg">
              </figure>
            </div>
          </div>

        </div>
      </section>
      <section class="d-inline-block getst-work-home-06 w-100">
        <div class="container position-relative">
          <FooterHint></FooterHint>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import TitAndBread from '@/components/TitAndBread';
import FooterHint from '@/components/FooterHint';
export default {
  name: '',
  components: { TitAndBread, FooterHint },
  props: {},
  data() {
    return {
    }
  },
  computed: {},
  watch: {},
  created() { },
  mounted() { },
  methods: {}
}
</script>

<style scoped lang="less">
.btnImg {
  svg {
    transform: rotate(45deg) scale(2) !important;
    padding-top: 8px;
    padding-left: 8px;
  }
} 
</style>
